const LOCAL_STORAGE_KEY = {
	SHOW_SITE_GPT: 'showSiteGpt',
	TOKEN: 'token',
	REFRESH: 'refresh',
	USER_NAME: 'userName',
	USER_ID: 'userId',
	SESSION_EXPIRED: 'session_expired',
	SOURCE: 'utm_source',
	MEDIUM: 'utm_medium',
	CAMPAIGN: 'utm_campaign',
	LAST_EXTRACTION_DATES: 'last_extraction_dates',
	OVERWRITE_UTM: 'overwrite_utm',
	PRICING_ELASTICY_SENT: 'pricing_elasticy_sent',
	ORGANIZATION_GOBACK: 'organization_go_back',
	LAST_ORDER_PURCHASE: 'lastOrderPurchase',
	IS_FROM_IOS: 'isFromIOS',
	PLATFORM_OS: 'platformOS',
	ANNUAL: 'annual_param',
	CHECKOUT: 'checkout_param',
	PRODUCT_ADDED: 'product_added',
	SKIP_SAMANTHA: 'skip_samantha',
	FLOW: 'flow',
	FLOW_PERIODICITY: 'flow_periodicity',
	SUBSCRIPTION_ID: 'subscription_id',
	ACCEPTED_NSS_VALIDATION: 'accepted_nss_validation',
	SHOW_MODAL_RECENT_ACQUISITION: 'show_modal_recent_acquisition',
};

export default LOCAL_STORAGE_KEY;
